import DeviceManager from '../utils/device-manager';
import Flickity from "flickity-fade";
import "flickity-imagesloaded";
import flickityEqualHeight from '../vendors/flickity-equal-height';
import "flickity-imagesloaded";

flickityEqualHeight();

class PartnersSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: false,
            imagesLoaded: true,
            freeScroll: true,
            cellSelector: '.partners-slider__slide'
        };

        if(this.$el.length) {
            this._init();
            this._bindEvents();
        }
    }

    _init() {
        this.$slides = this.$el.find('.partners-slider__slide');
        this.slidesCount = this.$slides.length;

        if(document.body.clientWidth < 620 && this.slidesCount > 1) {
            this._createSlider();
            console.log('slider mobile');
        } else if (document.body.clientWidth >= 620 && document.body.clientWidth < 820 && this.slidesCount > 2) {
            this._createSlider();
            console.log('slider 620-820');
        } else if (document.body.clientWidth >= 820 && document.body.clientWidth < 1200 && this.slidesCount > 3) {
            this._createSlider();
            console.log('slider 820-1200');
        } else if (document.body.clientWidth > 1199 && this.slidesCount > 4) {
            this._createSlider();
            console.log('slider +1200');
        } else {
            console.log("no slider");
        }
    }

    _bindEvents() {
        this._onBreakpointChangeFn = this._onBreakpointChange.bind(this);

        DeviceManager.on('device-manager:breakpointChange', this._onBreakpointChangeFn);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _onBreakpointChange() {
        if(document.body.clientWidth < 620 && this.slidesCount > 1){
            this._destroy();
            this._createSlider();
            console.log('slider resize mobile');
        } else if(document.body.clientWidth >= 620 && document.body.clientWidth < 820 && this.slidesCount > 2) {
            this._destroy();
            this._createSlider();
            console.log('slider resize 620-800');
        } else if(document.body.clientWidth >= 820 && document.body.clientWidth < 1200 && this.slidesCount > 3) {
            this._destroy();
            this._createSlider();
            console.log('slider resize 800-1200');
        } else if(document.body.clientWidth >= 1200 && this.slidesCount > 4) {
            this._destroy();
            this._createSlider();
            console.log('slider resize +1200');
        } else {
            this._destroy();
            console.log("slider destroyed");
        }
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }
}

export default PartnersSlider;
